import { useEffect } from "react";
import { customScript } from "../../common/customscript";
import Footer from "../../components/footer/footer"
import Header from "../../components/header/header"
import SearchModel from "../../components/search_model/search";
import TermSection from "../../components/terms/terms";

const Terms = () => {
    useEffect(() => {
        customScript()
    },[])

    return (
        <>
            <Header />
            <TermSection/>
            <Footer />
            <SearchModel/>
        </>
    )
}

export default Terms